/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formemail_Placeholder1Inputs */

const ja_contact_formemail_placeholder1 = /** @type {(inputs: Contact_Formemail_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`example@mail.com`)
};

const en_contact_formemail_placeholder1 = /** @type {(inputs: Contact_Formemail_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eg. your.name@coolcompany.com`)
};

/**
* | output |
* | --- |
* | "eg. your.name@coolcompany.com" |
*
* @param {Contact_Formemail_Placeholder1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formemail_placeholder1 = /** @type {((inputs?: Contact_Formemail_Placeholder1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formemail_Placeholder1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formemail_placeholder1(inputs)
	return en_contact_formemail_placeholder1(inputs)
});
export { contact_formemail_placeholder1 as "contact_formEmail_placeholder" }